import { createEntityAdapter } from "@reduxjs/toolkit";
import { Resource } from "./dataTypes";

export const resourceAdapter = createEntityAdapter<Resource>({});
